// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"131":"03b2bb19","491":"31d6cfe0","514":"3a27180a","800":"621e1df4"}[chunkId] + ".chunk.css";
};